import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  dateRangeValueConverter,
  formatDateTimeStamp,
  isLargeScreen,
} from '../../../../global.variable';
import { DatetimePickerComponent } from '../../../shared/components/datetime-picker/datetime-picker.component';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { UsersService } from '../users/users.service';
import { JobsService } from '../jobs/jobs.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'gtapp-subscriber-analytics',
  templateUrl: './subscriber-analytics.component.html',
  styleUrl: './subscriber-analytics.component.scss',
  standalone: false,
})
export class SubscriberAnalyticsComponent implements OnInit, OnDestroy {
  analyticsData: any = [];
  dateRange: any;
  dateRangeValue: any;

  inactiveUserList: any = [];
  largeView: Boolean = isLargeScreen;

  generalDataList: any = [];
  generalDataDict: any = {};

  jobTypesDataDict: any = {};

  analyticsDataDict: any = {
    clientCompletedJobDict: {
      countExists: false,
      showItem: false,
      previous: 0,
      pageSize: 10,
      totalRows: 0,
      pageNum: 1,
      totalPages: 0,
      totalItemCount: 0,
      listData: [],
      sortKey: [],
      searchParams: {},
      tableDetail: [
        {
          header: 'Client',
          name: 'name',
          sortKey: 'name',
          searchKey: this.largeView ? 'name' : false,
          tableColumnStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
          tableHeaderStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
        },
      ],
      otherParams: {},
    },
    userCompletedJobDict: {
      countExists: false,
      showItem: false,
      previous: 0,
      pageSize: 10,
      totalRows: 0,
      pageNum: 1,
      totalPages: 0,
      totalItemCount: 0,
      listData: [],
      sortKey: [],
      searchParams: {},
      tableDetail: [
        {
          header: 'User',
          name: 'name',
          sortKey: 'name',
          searchKey: this.largeView ? 'name' : false,
          tableColumnStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
          tableHeaderStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
        },
      ],
      otherParams: {},
    },
    clientCPScanDict: {
      countExists: false,
      showItem: false,
      previous: 0,
      pageSize: 10,
      totalRows: 0,
      pageNum: 1,
      totalPages: 0,
      totalItemCount: 0,
      listData: [],
      sortKey: [],
      searchParams: {},
      tableDetail: [
        {
          header: 'Client',
          name: 'name',
          sortKey: 'name',
          searchKey: this.largeView ? 'name' : false,
          tableColumnStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
          tableHeaderStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
        },
        {
          header: 'Scans',
          name: 'scan_count',
          sortKey: 'scan_count',
        },
      ],
      otherParams: {},
    },
    userCPScanDict: {
      countExists: false,
      showItem: false,
      previous: 0,
      pageSize: 10,
      totalRows: 0,
      pageNum: 1,
      totalPages: 0,
      totalItemCount: 0,
      listData: [],
      sortKey: [],
      searchParams: {},
      tableDetail: [
        {
          header: 'User',
          name: 'name',
          sortKey: 'name',
          searchKey: this.largeView ? 'name' : false,
          tableColumnStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
          tableHeaderStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
        },
        {
          header: 'Scans',
          name: 'scan_count',
          sortKey: 'scan_count',
        },
      ],
      otherParams: {},
    },
    clientIncidentsSentDict: {
      countExists: false,
      showItem: false,
      previous: 0,
      pageSize: 10,
      totalRows: 0,
      pageNum: 1,
      totalPages: 0,
      totalItemCount: 0,
      listData: [],
      sortKey: [],
      searchParams: {},
      tableDetail: [
        {
          header: 'Client',
          name: 'name',
          sortKey: 'name',
          searchKey: this.largeView ? 'name' : false,
          tableColumnStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
          tableHeaderStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
        },
        {
          header: 'Sent',
          name: 'incidents_sent',
          sortKey: 'incidents_sent',
        },
      ],
      otherParams: {},
    },
    userIncidentsSentDict: {
      countExists: false,
      showItem: false,
      previous: 0,
      pageSize: 10,
      totalRows: 0,
      pageNum: 1,
      totalPages: 0,
      totalItemCount: 0,
      listData: [],
      sortKey: [],
      searchParams: {},
      tableDetail: [
        {
          header: 'User',
          name: 'name',
          sortKey: 'name',
          searchKey: this.largeView ? 'name' : false,
          tableColumnStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
          tableHeaderStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
        },
        {
          header: 'Sent',
          name: 'incidents_sent',
          sortKey: 'incidents_sent',
        },
      ],
      otherParams: {},
    },
    missedScanDict: {
      countExists: false,
      showItem: false,
      previous: 0,
      pageSize: 10,
      totalRows: 0,
      pageNum: 1,
      totalPages: 0,
      totalItemCount: 0,
      listData: [],
      sortKey: [],
      searchParams: {},
      tableDetail: [
        {
          header: 'Client',
          name: 'name',
          sortKey: 'name',
          searchKey: this.largeView ? 'name' : false,
          tableColumnStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
          tableHeaderStyle: {
            'position': 'sticky',
            'left': 0,
            'background-color': 'var(--bs-table-bg)',
            'z-index': 10,
            'white-space': 'nowrap',
          },
        },
        {
          header: 'Count',
          name: 'missed_scans',
          sortKey: 'missed_scans',
        },
      ],
      otherParams: {},
    },
  };

  loopTableData: any = [
    {
      dataKey: 'client_jobs',
      dictKey: 'clientCompletedJobDict',
      header: 'Jobs Completed - Client',
    },
    {
      dataKey: 'user_jobs',
      dictKey: 'userCompletedJobDict',
      header: 'Jobs Completed - User',
    },
    {
      dataKey: 'client_cp_scan_count',
      dictKey: 'clientCPScanDict',
      header: 'Checkpoint Scans - Client',
    },
    {
      dataKey: 'user_cp_scan_count',
      dictKey: 'userCPScanDict',
      header: 'Checkpoint Scans - User',
    },
    {
      dataKey: 'client_incidents_sent_count',
      dictKey: 'clientIncidentsSentDict',
      header: 'Incidents Sent - Client',
    },
    {
      dataKey: 'user_incidents_sent_count',
      dictKey: 'userIncidentsSentDict',
      header: 'Incidents Sent - User',
    },
    {
      dataKey: 'missed_scan_count',
      dictKey: 'missedScanDict',
      header: 'Missed Scans',
    },
  ];

  userHoursRosteredDict: any = {};
  userHoursRosteredSubject = new Subject<void>();
  previousUserHoursRostered: number = 0;

  itemsPulledUserHoursRosteredCount: number = 0;
  userHoursRosteredDataPulled = false;
  pageSizeUserHoursRostered: number = 25;
  otherParamsUserHoursRostered: any = {};
  listDataUserHoursRostered: any = [];
  tableDetailUserHoursRostered: any = [
    {
      header: 'User',
      name: 'name',
      sortKey: 'name',
      searchKey: this.largeView ? 'name' : false,
      tableColumnStyle: {
        'position': 'sticky',
        'left': 0,
        'background-color': 'var(--bs-table-bg)',
        'z-index': 10,
        'white-space': 'nowrap',
      },
      tableHeaderStyle: {
        'position': 'sticky',
        'left': 0,
        'background-color': 'var(--bs-table-bg)',
        'z-index': 10,
        'white-space': 'nowrap',
      },
    },
    {
      header: 'Shifts',
      name: 'shifts',
      sortKey: 'shifts',
    },
    {
      header: 'Hours',
      name: 'hours',
      sortKey: 'hours',
    },
  ];

  constructor(
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private userService: UsersService,
    private dialogService: ModalDialogueService,
    private jobService: JobsService,
  ) {}
  ngOnInit(): void {
    this.getJobTypes();
    const lastWeek = new Date();
    lastWeek.setDate(new Date().getDate() - 7);
    this.dateRange = { start: lastWeek, end: new Date() };
    this.dateRangeValue = `${dateRangeValueConverter(
      this.dateRange?.start,
      true,
    )} - \n ${dateRangeValueConverter(this.dateRange?.end, true)}`;
    this.getAnalyticsData();
    this.getAnalyticsData(2);
  }
  ngOnDestroy(): void {
    if (this.userHoursRosteredSubject) {
      this.userHoursRosteredSubject?.next();
      this.userHoursRosteredSubject?.complete();
    }
  }

  getJobTypes() {
    this.jobService.getJobParams().subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.jobTypesDataDict = {};

        response?.data?.forEach((element: any) => {
          if (element?.type_identity !== 4)
            this.jobTypesDataDict[element?.id] = element?.name;
        });

        if (Object.keys(this.jobTypesDataDict || {})?.length) {
          Object.entries(this.jobTypesDataDict || {}).forEach(
            ([key, value]) => {
              this.analyticsDataDict?.clientCompletedJobDict?.tableDetail?.push(
                {
                  header: value,
                  nestedValue: (row: any) => {
                    return row?.[key] || 0;
                  },
                  sortKey: key,
                },
              );
              this.analyticsDataDict?.userCompletedJobDict?.tableDetail?.push({
                header: value,
                nestedValue: (row: any) => {
                  return row?.[key] || 0;
                },
                sortKey: key,
              });
            },
          );
          this.analyticsDataDict?.clientCompletedJobDict?.tableDetail?.push({
            header: 'Total',
            name: 'job_total',
            sortKey: 'job_total',
          });
          this.analyticsDataDict?.userCompletedJobDict?.tableDetail?.push({
            header: 'Total',
            name: 'job_total',
            sortKey: 'job_total',
          });
        }
      }
    });
  }
  formatGeneralData(data: any) {
    this.generalDataDict = { ...(this.generalDataDict || {}), ...(data || {}) };
    Object.entries(this.generalDataDict).forEach(([key, value]) => {
      const count: any = value;

      if (count > 0) {
        const existingItem = this.generalDataList.find(
          (item: any) => item?.name === key,
        );

        if (!existingItem) {
          this.generalDataList.push({ name: key, value: value });
        }
      }
    });
    const expandSectionAvailable = this.generalDataList?.some((item: any) =>
      Object.values(this.jobTypesDataDict).includes(item?.name),
    );
    this.analyticsDataDict.clientCompletedJobDict.showItem =
      expandSectionAvailable;
    this.analyticsDataDict.userCompletedJobDict.showItem =
      expandSectionAvailable;

    this.analyticsDataDict.userIncidentsSentDict.showItem =
      this.generalDataDict?.['Incidents Sent'] > 0;

    this.analyticsDataDict.clientIncidentsSentDict.showItem =
      this.generalDataDict?.['Incidents Sent'] > 0;

    this.analyticsDataDict.userCPScanDict.showItem =
      this.generalDataDict?.['Checkpoint Scans'] > 0;

    this.analyticsDataDict.clientCPScanDict.showItem =
      this.generalDataDict?.['Checkpoint Scans'] > 0;
    this.analyticsDataDict.missedScanDict.showItem =
      this.generalDataDict?.['Missed Scans'] > 0;
  }
  getAnalyticsData(section = 0) {
    this.spinnerService.show();

    let params: any = {};
    switch (section) {
      case 0:
        params.analytics_section = 'general_jobs';
        break;
      case 1:
        params.analytics_section = 'inactive_users';
        break;
      case 2:
        params.analytics_section = 'general_basics';
        break;
    }
    let body: any = { event_type: 'subscriber_analytics' };
    if (this.dateRange) body.date_range = this.dateRange;

    this.userService
      .getUserUpdateLog(body, params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          switch (section) {
            case 0:
              this.formatGeneralData(response?.data?.general_data || {});

              break;
            case 2:
              this.formatGeneralData(response?.data?.general_data || {});
              break;

            case 1:
              this.inactiveUserList = response?.data?.inactive_users;
              break;
          }

          this.spinnerService.hide();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
          this.spinnerService.hide();
        }
      });
  }

  openRangePicker() {
    const dialogeRef = this.dialogService.open(DatetimePickerComponent, {
      data: {
        dateRange: this.dateRange,
        showDateOnly: true,
        showFrom: 'tablePage',
      },
    });
    dialogeRef.afterClosed().subscribe((value: any) => {
      if (value !== 'close') {
        this.dateRange = value;

        this.dateRangeValue = `${dateRangeValueConverter(
          this.dateRange?.start,
          true,
        )} - \n ${dateRangeValueConverter(this.dateRange?.end, true)}`;
        this.loopTableData?.forEach((element: any) => {
          this.analyticsDataDict[element?.dictKey].countExists = false;
        });

        this.inactiveUserList = [];
        this.generalDataList = [];
        this.generalDataDict = {};
        this.listDataUserHoursRostered = [];
        this.userHoursRosteredDict = {};
        this.itemsPulledUserHoursRosteredCount = 0;
        this.userHoursRosteredDataPulled = false;
        this.previousUserHoursRostered = 0;
        this.userHoursRosteredSubject?.next();
        this.getAnalyticsData();
        this.getAnalyticsData(2);
      }
    });
  }
  getDataKey(section: string): string {
    let dataKey: string = '';
    switch (section) {
      case 'client_jobs':
        dataKey = 'clientCompletedJobDict';
        break;
      case 'user_jobs':
        dataKey = 'userCompletedJobDict';
        break;
      case 'client_cp_scan_count':
        dataKey = 'clientCPScanDict';
        break;
      case 'user_cp_scan_count':
        dataKey = 'userCPScanDict';
        break;
      case 'client_incidents_sent_count':
        dataKey = 'clientIncidentsSentDict';
        break;
      case 'user_incidents_sent_count':
        dataKey = 'userIncidentsSentDict';
        break;
      case 'missed_scan_count':
        dataKey = 'missedScanDict';
        break;
    }
    return dataKey;
  }
  getIndividualAnalytics(section: string) {
    let body: any = { event_type: 'subscriber_analytics' };
    let params: any = { analytics_section: section };

    let dataKey: string = this.getDataKey(section);
    let dataBody: any = this.analyticsDataDict?.[dataKey];

    if (dataBody?.pageSize) {
      body['rows'] = dataBody?.pageSize;
    }
    if (dataBody?.previous) {
      body['previous'] = dataBody?.previous;
    }
    if (dataBody?.sortKey) {
      body['sort_key'] = dataBody?.sortKey;
    }
    if (dataBody?.searchParams) {
      body['search_filters'] = dataBody?.searchParams;
    }

    if (this.dateRange) body.date_range = this.dateRange;
    this.spinnerService.show();
    this.userService
      .getUserUpdateLog(body, params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.analyticsDataDict[dataKey].totalRows = response['total_size'];
          this.analyticsDataDict[dataKey].totalItemCount = Math.max(
            this.analyticsDataDict[dataKey]?.totalItemCount || 0,
            response['total_size'],
          );

          this.analyticsDataDict[dataKey].countExists = Boolean(
            (this.analyticsDataDict?.[dataKey]?.countExists ||
              response['total_size']) > 0,
          );

          this.analyticsDataDict[dataKey].otherParams.paginationData = {
            totalRows: response['total_size'],
            previousRows: dataBody?.previous,
            rows: dataBody?.pageSize,
            pageNum: dataBody?.pageNum,
          };

          this.analyticsDataDict[dataKey].listData = response?.data;
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            errorMessage: response['message'],
            successMessage: '',
          });
        }
      });
  }
  onChangeAnalyticPagination(data: any, section: string) {
    let dataKey: string = this.getDataKey(section);
    this.analyticsDataDict[dataKey].previous =
      data?.paginationData?.previousRows;
    this.analyticsDataDict[dataKey].pageNum = data?.paginationData?.pageNum;
    this.analyticsDataDict[dataKey].pageSize = data?.paginationData?.rows;

    this.analyticsDataDict[dataKey].otherParams.paginationData = {
      ...data?.paginationData,
    };
    this.getIndividualAnalytics(section);
  }
  onSortIndividualAnalytic(body: any, section: string) {
    let dataKey: string = this.getDataKey(section);
    this.analyticsDataDict[dataKey].sortKey = body?.sortList || [];
    this.analyticsDataDict[dataKey].searchParams = body?.searchParams || {};
    this.getIndividualAnalytics(section);
  }
  onSearchIndividualAnalytic(event: any, section: string) {
    let dataKey: string = this.getDataKey(section);
    this.analyticsDataDict[dataKey].previous = 0;
    this.analyticsDataDict[dataKey].searchParams = event?.searchParams || {};

    this.analyticsDataDict[dataKey].pageNum = 1;
    this.getIndividualAnalytics(section);
  }
  formatUserHoursData(response: any) {
    this.itemsPulledUserHoursRosteredCount += (response?.data || [])?.length;
    const totalItems = response?.total_size || 0;
    response?.data?.forEach((element: any) => {
      const userId = element?.user_id;
      const seconds = Number(element?.hours_rostered ?? 0);

      if (!(userId in this.userHoursRosteredDict)) {
        this.userHoursRosteredDict[userId] = {
          name: element?.user_name,
          shifts: 0,
          totalSeconds: 0,
        };
      }

      this.userHoursRosteredDict[userId].shifts += 1;
      this.userHoursRosteredDict[userId].totalSeconds += seconds;
    });

    this.listDataUserHoursRostered = Object.values(
      this.userHoursRosteredDict,
    )?.map((user: any) => ({
      name: user.name,
      shifts: user.shifts,
      hours: this.secondsToHHMM(user.totalSeconds),
    }));
    if (totalItems > 0 && this.itemsPulledUserHoursRosteredCount < totalItems) {
      this.previousUserHoursRostered += this.pageSizeUserHoursRostered;
      this.getUserHoursRosteredData();
    }
  }
  secondsToHHMM(totalSeconds: number): string {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`;
  }
  getUserHoursRosteredData() {
    let body: any = {
      event_type: 'subscriber_analytics',
      rows: this.pageSizeUserHoursRostered,
    };
    let params: any = { analytics_section: 'user_hours_rostered' };

    if (this.previousUserHoursRostered) {
      body['previous'] = this.previousUserHoursRostered;
    }

    if (this.dateRange) body.date_range = this.dateRange;

    this.userService
      .getUserUpdateLog(body, params)
      .pipe(takeUntil(this.userHoursRosteredSubject))
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.userHoursRosteredDataPulled = true;
          this.formatUserHoursData(response);
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            errorMessage: response['message'],
            successMessage: '',
          });
        }
      });
  }
}
